"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import FocusLock from 'react-focus-lock';
import { useComboBox } from '../context/use-combobox.mjs';

const TRAP_GROUP = "combobox-dropdown";
function DropdownFocusTrap({
  children,
  className,
  disabled: popoverDisabled
}) {
  const { isDropdownOpen, scopedComboboxId } = useComboBox();
  return /* @__PURE__ */ jsx(
    FocusLock,
    {
      group: TRAP_GROUP + scopedComboboxId,
      disabled: !isDropdownOpen || popoverDisabled,
      returnFocus: false,
      autoFocus: popoverDisabled,
      className,
      children
    }
  );
}

export { DropdownFocusTrap };
